export const FOLDERS = {
  'Work': { hasArrow: true, subfolders: ['About', 'Projects', 'AI Trash'] },
  'Spotify': { hasArrow: true, subfolders: ['coming soon'] },
  'Vimarsh_XP': { hasArrow: true, subfolders: ['coming soon'] },
  'Thoughts': { hasArrow: true, subfolders: [] },
  'Top_Secret': { hasArrow: true, subfolders: ['manga_me'] }
};

export const FILES = {
  'About': ['about_me.pdf', 'experience.pdf', 'tools.pdf', 'skills.pdf', 'resume.pdf'],
  'Thoughts': ['how_engineers_run_china.md'],
  'manga_me': ['manga_me.exe']
};

export const PROFILE_DATA = {
  name: 'Vimarsh Tiwari',
  tagline: 'Building products & shadow clones!',
  location: 'Bengaluru, IND',
  image: '/pfp.png',
  bannerImage: '/about-banner.png'
};

export const BIO = {
  short: "I'm a Product Manager with experience in building  AI, Web3 & Travel Tech products from 0-1.",
  long: "My background spans product design, GTM strategy, and leadership — from launching early-stage tools to optimizing processes for scale. I'm passionate about building products that combine intelligence, usability, and strong execution."
};

export const ABOUT = {
  intro: "Hey, I'm Vimarsh — a Product Manager and creative technologist with experience leading 0 to 1 product launches across AI, travel tech, and web3.",
  description: "My work spans from designing AI agents that generate production-ready UI to scaling community-driven products to thousands of users. I love working at the intersection of strategy, design, and technology — shaping ideas that are as functional as they are creative.",
  experiences: [
    {
      title: "HUE AI",
      description: "Built autonomous UI generation agent that converts natural language to production HTML — scaled to 1,000 users in 4 months with 85% zero-revision acceptance rate.",
      details: [
        "Architected multi-agent pipeline with 7 specialized stages (decomposition, competitive analysis, design system, content, code, validation, assets) — reduced failure rate from 40% to 8% through systematic validation at each handoff.",
        "Built RAG library of 1,000+ design references indexed by industry and component type — grounded agent outputs in real-world patterns, cutting subjective 'this looks wrong' failures by 60%.",
        "Achieved 85% first-try acceptance rate by validating layout conflicts, dependencies, accessibility, and responsive behavior before user sees output — proving autonomous code can be production-ready.",
        "Grew to 1,000 users through community distribution (Product Hunt, indie maker forums) with zero paid spend — reduced support volume 60% via power user feedback loops and systematic failure triage."
      ]
    },
    {
      title: "ATOMVERSE",
      description: "Co-founded Atomverse (generative PFP NFT project) — led 15-person art team through high-pressure launch, scaled to 50K organic community, and generated $1.2M revenue in under 30 minutes.",
      details: [
        "Directed generative art pipeline coordinating 15 3D designers to deliver 4444 unique assets on fixed timeline — managed creative direction, quality standards, and technical constraints (on-chain metadata, rarity distribution, render optimization).",
        "Scaled community from 0→50K in 3 months through organic growth strategy (Twitter Spaces, Discord engagement, influencer partnerships) with zero paid acquisition — built authentic community in oversaturated market.",
        "Executed launch coordination across art, smart contracts, marketing, and community — delivered sold-out mint ($1.2M) in <30 minutes, then shipped roadmap utilities (member perks, exclusive access) before strategic wind-down after 1 year."
      ]
    },
    {
      title: "WAYLO",
      description: "Founding Designer at Waylo (AI hotel booking platform) — sole designer for 4 years from founding through acquisition by eDreams ODIGEO, one of Europe's largest travel companies.",
      details: [
        "Designed entire product experience (booking flow, brand identity, marketing site, email campaigns, pitch decks) as the only designer on 5-person founding team — owned visual design, user research, and A/B testing that contributed to $1M GMV in 3 months.",
        "Led design for predictive pricing feature (AI model forecasting hotel price drops, enabling users to lock in future discounts) — designed booking flow that made price arbitrage understandable and trustworthy, converting price-sensitive travelers at rates above industry baseline.",
        "Won Phocuswright Innovation Award through combination of product design, user testing, and systematic iteration on conversion funnel — design work helped position Waylo for acquisition by €600M+ travel platform eDreams ODIGEO."
      ]
    }
  ]
};

export const SKILLS = [
  'Product Strategy & Roadmapping',
  'User Research & JTBD',
  'AI Product Design & Multi-Agent Systems',
  'Design Systems & UI Architecture',
  'Growth, GTM & Community Distribution',
  'Agile Delivery, OKRs, Data-Driven Execution'
];

export const NOW_PLAYING = {
  title: 'BUTTERFLY EFFECT',
  artist: 'Travis Scott',
  progress: 35
};

export const CASE_STUDIES = {
  'Projects': {
    'Blinkit Growth Strategy': {
      title: 'Blinkit Growth Strategy',
      banner: '/blinkit.png',
      link: 'https://docs.google.com/document/d/1_mAsEbbpeTS4b94AOE2P-kUCK8WioRUTAsIgqxmf7wc/edit?usp=sharing',
      summary: "## Habit Engine — Blinkit Case Study\n\nBlinkit isn't just delivering groceries — it's reshaping how India shops.  \nWith a **40% market share** and over **30 million weekly active users**, it recently overtook Zomato's food delivery business.\n\nThe challenge was simple but high-stakes: turn casual, deal-driven shoppers into loyal, high-frequency users.\n\nI focused on three key levers:\n\n- **Frequency:** driving 2+ orders a week through habit loops  \n- **Breadth:** expanding beyond perishables into beauty, electronics, and home essentials  \n- **Trust:** reinforcing the \"10-min or free\" promise to make Blinkit the go-to app\n\nI mapped three core user personas — Value Hunters, Speed Seekers, and Urgency Queens — and built tailored engagement loops for each.  \nGamified streaks, time-bound flash sales, and reliability guarantees helped boost retention to **67%+** and reduce churn from delivery delays.\n\n**Result:** a strategy that turned quick commerce into **sticky commerce**, making Blinkit not just fast — but the **default choice** for millions.",
      caseStudyId: 'blinkit'
    },
    'Rapido Recurring Rides': {
      title: 'Rapido Recurring Rides',
      banner: '/rapido.png',
      link: 'https://docs.google.com/document/d/1qwrOFFTvtk5SloLzOm6cV8zTrVeFjBRPv49oboQ7EME/edit?usp=sharing',
      summary: "## Ride Routine — Rapido Case Study\n\nRapido has always promised quick and affordable rides — but for daily commuters, **reliability mattered more than price**.  \n\nPeak-hour rides were still unpredictable: cancellations, surge fares, and last-minute stress.\n\nI designed **Recurring Rides**, a feature that lets users pre-book their commutes for **7, 14, or 28 days** — essentially a *\"metro pass for Rapido.\"*\n\nMy approach focused on two sides of reliability:\n\n- **For riders:** guaranteed rides, surge-free pricing, and flexible skip options  \n- **For Captains:** predictable demand blocks and steadier income\n\nThe pilot projected:\n\n- **+15% retention uplift**  \n- **-20% peak-hour cancellations**  \n- **+10-15% ARPU growth**\n\nRecurring Rides turned Rapido from a ride-hailing app into a **commuting utility** — dependable, habitual, and built for everyday life.",
      caseStudyId: 'rapido'
    }
  }
};
